import {observable, action, computed, ObservableMap, makeObservable, observe} from 'mobx';
import {sortingArrangeEnum, tableDataType, tableActionType} from "../serverClientShared/sharedEnums";
import {TableRequester} from "../MobxStores/RequestApi/TableRequester"
import { getSelectedValues } from '../Components/Generic/GenericTable/tableHelpers';

export class TableStore {
    columns = [];
    urls = {
        [tableActionType.FETCH]: "",
        [tableActionType.DELETE]: "",
        [tableActionType.CREATE_OR_UPDATE]: ""
    };
    data =  [];

    filters =[] // {type: tableDataType, name, value, options, isMultipleOptions, column, displayName}
    currentPage = 1;
    itemsPerPage = 12;
    totalItems = 200;
    sortColumn = null;
    sortDirection = sortingArrangeEnum.ASCENDING;
    searchQuery ='';
    modalState = {value: "", error: null, type: "create"};
    title= "";
    createText = null;
    noDataText = null;
    editingRowId = null;
    createShake = false;
    onCreateMouseDown = null;
    currentRow = null;
    handleCreateModal = null;
    isRowHover = false;
    isScrollable= false;
    tableListRef ={};
    scrollState = false;
    hasMoreData = true;
    generateReportsText = null;
    isBatchChanges = false;
    editedObjects = []
    batchesActions = [];
    IsDeletedField ='IsDeleted';
    primaryKeyFieldInDb = 'Identifier';
    selectedObjectsMap = new Map();
    deleteConfirmationMessage = ()=><div></div>
    successDeleteMessage = ''
    deleteEntityName = 'item'
    displayNameField = null
    deleteWarningText = null
    triggerRender = 0
    isSelectAll = false
    excludedRowsIds = new Set()
    protectedCount = 0
    fetchGeneration = 0
    lastSelectedIndex = null


    onAfterEdit = null;
    isRowSelectable = null;
    customDeleteHandler = null;
    generateReportsAction =()=>{}

    constructor(modalStore) {
        makeObservable(this, {
            columns: observable,
            urls: observable,
            data: observable,
            title: observable,
            createText: observable,
            noDataText: observable,
            editingRowId: observable,
            createShake: observable,
            onCreateMouseDown: observable,
            currentPage: observable,
            itemsPerPage: observable,
            totalItems: observable,
            isSelectAll: observable,
            excludedRowsIds: observable,
            protectedCount: observable,
            sortColumn: observable,
            sortDirection: observable,
            filters: observable,
            searchQuery: observable,
            modalState: observable,
            currentRow: observable,
            handleCreateModal: observable,
            isRowHover: observable,
            isScrollable: observable,
            tableListRef: observable,
            scrollState: observable,
            hasMoreData: observable,
            triggerRender: observable,
            fetchGeneration: observable,
            generateReportsText: observable,
            generateReportsAction: observable,
            isBatchChanges: observable,
            editedObjects: observable,
            batchesActions: observable,
            IsDeletedField: observable,
            primaryKeyFieldInDb: observable,
            selectedObjectsMap: observable,
            deleteConfirmationMessage: observable,
            successDeleteMessage: observable,
            deleteWarningText: observable,
            deleteEntityName: observable,
            displayNameField: observable,
            hasActiveFilters: computed,
            searchColumns: computed,
            startItem: computed,
            endItem: computed,
            totalPages: computed,
            isGenericModalOpen: computed,
            handleOpenModal: action,
            handleFetch :action,
            handleRowClick: action,
            showErrorMessage: action,
            refresh:action,
            getByPath: action,
            handleDelete: action,
            handleOpenDeleteModal: action,
            clearAllFilters: action,

    });
        this.modalStore = modalStore;

    }
    get isGenericModalOpen (){
        return this.modalStore.isGenericModalOpen
    }
    get startItem () {
        return (this.currentPage - 1) * this.itemsPerPage + 1;
    }
    get endItem() {
        return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
    }
    get totalPages() {
        return Math.ceil(this.totalItems / this.itemsPerPage);
    }
    get hasActiveFilters() {
        return this.filters.some(filter => {
            if (filter.getCount) return filter.getCount(filter.value) > 0;
            const val = filter.value;
            if (filter.type === tableDataType.BOOLEAN) return val !== false;
            return val !== '' && val !== null && val?.length !== 0;
        });
    }

    resetPagination = () => {
        this.currentPage = 1;
        this.scrollState = false;
        this.hasMoreData = true;
        this.triggerRender += 1;
    };

    clearAllFilters = () => {
        this.filters = this.filters.map(filter => {
            if (filter.clearValue !== undefined) return {...filter, value: filter.clearValue};
            if (filter.getCount) return {...filter, value: Array.isArray(filter.value) ? [] : null};
            return {...filter, value: filter.isMultipleOptions ? [] : null};
        });
        this.resetPagination();
    };

    get searchColumns() {
        return this.columns
            .map(col => col.searchable ? col.fieldInDb : undefined)
            .filter(field => field !== undefined);
    }
    showErrorMessage(message) {
        this.modalStore.showErrorMessage(message);
    }

    handleOpenModal(title, handleModalAction) {
        this.modalStore.modalData= {
            ...this.modalStore.modalData,
            modalState: this.modalState,
            title: title,
            handleModalAction: handleModalAction,
        }
        this.modalStore.isGenericModalOpen = true
    }

    handleEditData = async (newData, newChangeField = null, extraCondition = null)=> {
        const snapshots = [];
        try {
            this.isLoading = true;

            if (newData && Array.isArray(newData)) {
                newData.forEach(updated => {
                    const index = this.data.findIndex(item =>
                        item[this.primaryKeyFieldInDb] === updated[this.primaryKeyFieldInDb]
                    );
                    if (index !== -1) {
                        snapshots.push({index, data: {...this.data[index]}});
                        this.data[index] = { ...this.data[index], ...updated };
                    }
                });
                this.syncSelectedObjects();
            }
            let data = {newData, isSelectedAll: false, ...extraCondition}
            if (this.isSelectAll && newChangeField !== null){
                const query = this.buildQuery();
                data = {newData, isSelectedAll: true, newChangeField, excludedRowsIds: [...this.excludedRowsIds], query, ...extraCondition}
            }
            const updatedData = await TableRequester.editTableData(this.urls[tableActionType.CREATE_OR_UPDATE], data);
            if (updatedData && Array.isArray(updatedData) && updatedData.length > 0) {
                updatedData.forEach(updated => {
                    const index = this.data.findIndex(item =>
                        item[this.primaryKeyFieldInDb] === updated[this.primaryKeyFieldInDb]
                    );
                    if (index !== -1) {
                        this.data[index] = { ...this.data[index], ...updated };
                    }
                });
            }
            this.syncSelectedObjects();
            if (this.onAfterEdit) this.onAfterEdit();
        } catch (e) {
            snapshots.forEach(({index, data}) => { this.data[index] = data; });
            const serverMessage = e?.response?.data?.error;
            this.modalStore.showErrorMessage(serverMessage || 'Error editing data. Please try again later.');
        } finally {
            this.isLoading = false;
        }
    }
    getByPath(obj, path) {
        return path.split('.').reduce((acc, key) => acc?.[key], obj);
    }
    handleFetch = async() => {
        const generation = ++this.fetchGeneration;
        try {
            const query = this.buildQuery();
            if (!this.urls[tableActionType.FETCH]) return
            const {data, totalCount} = await TableRequester.fetchTableData(this.urls[tableActionType.FETCH], query);
            if (generation !== this.fetchGeneration) return;
            if (totalCount){
                this.totalItems = totalCount
                if (totalCount > (this.scrollState ? this.data.length : 0) + data.length){
                    this.hasMoreData = true;
                } else {
                    this.hasMoreData = false;
                }
            } else if (data.length === 0) {
                this.hasMoreData = false;
            }
            if (this.scrollState) {
                const existingIds = new Set(this.data.map(item => item[this.primaryKeyFieldInDb]));
                const newItems = data.filter(item => !existingIds.has(item[this.primaryKeyFieldInDb]));
                this.data = [...this.data, ...newItems];
                this.scrollState = false
            } else {
                this.data = data;
            }
            this.syncSelectedObjects();
        } catch (e) {
            if (generation !== this.fetchGeneration) return;
            console.error('Failed to fetch table data:', e);
        } finally {
            if (generation === this.fetchGeneration) this.isLoading = false;
        }

    };
    buildQuery = () => {
        const filters = [];
        const toolbarFilters = [];

        if (this.filters.length > 0) {
            this.filters.forEach(filter => {
                if (filter.key && filter.getCount) {
                    if (filter.getCount(filter.value) > 0) {
                        toolbarFilters.push({key: filter.key, value: filter.value});
                    }
                    return;
                }
                const val = filter.value;
                const hasValue =
                    (filter.type === tableDataType.BOOLEAN && val !== false) ||
                    (filter.type !== tableDataType.BOOLEAN && val !== '' && val !== null && val.length !== 0);
                if (hasValue) {
                    filters.push({
                        column: filter.column,
                        value: val,
                        isMultipleOptions: !!filter.isMultipleOptions,
                    });
                }
            });
        }

        return {
            filters,
            toolbarFilters,
            searchQuery: this.searchQuery || '',
            searchColumns: this.searchColumns || [],
            sortColumn: this.sortColumn || null,
            sortDirection: this.sortDirection || null,
            skip: this.startItem - 1,
            limit: this.itemsPerPage,
        };
    }

    handleRowClick = (row) => {
        this.currentRow = row
    }
    clearSelection() {
        this.selectedObjectsMap.clear();
        this.lastSelectedIndex = null;
    }
    syncSelectedObjects() {
        if (this.selectedObjectsMap.size === 0) return;
        const dataById = new Map(this.data.map(item => [item[this.primaryKeyFieldInDb], item]));
        for (const [id] of this.selectedObjectsMap) {
            const fresh = dataById.get(id);
            if (fresh) this.selectedObjectsMap.set(id, fresh);
        }
    }
    refresh = async () => {
        this.currentPage = 1;
        this.scrollState = false;
        this.hasMoreData = true;
        await this.handleFetch();
    };

    handleDelete = async () => {
        const currentValues = getSelectedValues(this);

        const newData = currentValues.map(item => ({
            ...item,
            [this.IsDeletedField]: true
        }));

        if (newData.length > 0) {
            await this.handleEditData(newData, {[this.IsDeletedField]: true});
            this.clearSelection();
            await this.refresh();
            this.modalStore.showSuccessMessage(this.successDeleteMessage || 'Successfully deleted selected ojects.');
        }
    }


    getDeleteBodyText = () => {
        const currentValues = Array.from(this.selectedObjectsMap.values());
        const count = currentValues.length;
        const entity = this.deleteEntityName;

        if (count === 1 && this.displayNameField) {
            const name = currentValues[0][this.displayNameField];
            return `Are you sure you want to delete "${name}"?`;
        }

        return `Are you sure you want to delete ${count} selected ${entity}${count > 1 ? 's' : ''}?`;
    }

    handleOpenDeleteModal = () => {
        if (this.customDeleteHandler) {
            this.customDeleteHandler();
            return;
        }
        const currentIdentifiers = Array.from(this.selectedObjectsMap.keys());
        if (currentIdentifiers.length === 0) return;
        const deleteAction = {
            title: 'Confirm Deleting',
            body: (
                <div className="flex flex-col attention-body-text">
                    {`Are you sure you want to delete ${currentIdentifiers.length} selected file${currentIdentifiers.length >1 ?'s':''}?`}
                    {this.deleteWarningText && <p className="mt-2">{this.deleteWarningText}</p>}
                </div>
            ),
            confirmText: 'Delete',
            confirmAction: this.handleDelete,
            isDelete: true
        };

        this.modalStore.modalData = {
            ...this.modalStore.modalData,
            title: deleteAction.title,
            bodyText: deleteAction.body,
            confirmText: deleteAction.confirmText,
            cancelText: deleteAction.cancelText,
            confirmActions: deleteAction.confirmAction,
            isDelete: deleteAction.isDelete,
            goBackControl: deleteAction.goBackControl,
            extraCloseActions: deleteAction.extraCloseActions,
            isChangedColorButtons: deleteAction.isChangedColorButtons ?? false
        };

        this.modalStore.isGeneralConfirmActionDialogOpen = true;
    }


    resetData = () => {
        this.fetchGeneration++;
        this.data = [];
        this.currentPage = 1;
        this.hasMoreData = true;
        this.searchQuery = '';
        this.selectedObjectsMap.clear();
        this.excludedRowsIds = new Set();
        this.isSelectAll = false;
        this.lastSelectedIndex = null;
        this.protectedCount = 0;
        this.createText = null;
        this.noDataText = null;
        this.editingRowId = null;
        this.createShake = false;
        this.onCreateMouseDown = null;
        this.isRowHover = false;
        this.deleteEntityName = 'item';
        this.displayNameField = null;
        this.deleteWarningText = null;
        this.successDeleteMessage = '';
        this.searchPlaceholder = null;
        this.toolbarWidgets = null;
        this.deleteWarningText = null;
        this.onAfterEdit = null;
        this.isRowSelectable = null;
        this.onUnselectableRowClick = null;
        this.customDeleteHandler = null;
        this.columns = [];
        this.urls = {
            [tableActionType.FETCH]: "",
            [tableActionType.DELETE]: "",
            [tableActionType.CREATE_OR_UPDATE]: ""
        };
    }

}